<template>
  <MenuItem :data="diagnosisList" header="Diagnosis"/>
</template>
<script>
import MenuItem from './components/MenuItem';
import { modelOpenRouter } from '@/mixins/model-open';
import { mapGetters } from 'vuex';
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import * as connectBikeAPI from '@/api/connect-bike';

export default {
  name: 'Diagnosis',
  mixins: [modelOpenRouter],
  components: {
    MenuItem
  },
  data () {
    return {
      diagnosisList: [
        {
          id: 'diagnosisHmi',
          img: 'item_part_display.png',
          item: 'HMI',
          path: 'diagnosis/hmi'
        },
        {
          id: 'diagnosisDriver',
          img: 'item_part_driver.png',
          item: 'Driver',
          path: 'diagnosis/driver'
        },
        {
          id: 'diagnosisMotor',
          img: 'item_part_motor.png',
          item: 'Motor',
          path: 'diagnosis/motor'
        },
        {
          id: 'diagnosisSensor',
          img: 'item_part_torque_sensor.png',
          item: 'Sensor',
          path: 'diagnosis/sensor'
        },
        {
          id: 'diagnosisBattery',
          img: 'item_part_battery.png',
          item: 'Battery',
          path: 'diagnosis/battery'
        },
        {
          id: 'diagnosisFinishAndCreateReport',
          img: 'item_confirm.png',
          item: 'Finish and Create Report',
          path: 'diagnosis/confirm'
        }
      ],
      activeNavIndex: 0
    };
  },
  created () {
    this.getConsoleInfo();
    if (this.getDeviceInfo['DriverType'] === 'M') {
      this.diagnosisList.splice(1, 1);
    }
  },
  computed: {
    ...mapGetters({
      // getUser: 'user/getUser',
      getDeviceInfo: 'bikeConnect/getDeviceInfo'
    })
  },
  methods: {
    async getConsoleInfo () {
      const encryptData = funcEncryptData({ PartNo: this.getDeviceInfo.ConsolePN });
      const data = await connectBikeAPI.getConsoleInfo(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      // console.log("TCL: getConsoleInfo -> data", data)

      if (data.ErrorCode === 0) {
        this.$store.dispatch('diagnosis/addIsLcm', data.IncludeLCM);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .modal-backdrop {
    background-color: $white !important;
  }
</style>
